// The book, deal by deal — every active deal, closest to close first.
//
// Also the table view behind every chart above it: any value a chart shows on
// hover is printed here, so nothing on Home depends on a tooltip to be read.
import { stageRamp } from "../common/brand";
import { STAGE_LABEL } from "../../services/homeView";

const M = (v) => `$${(v / 1e6).toFixed(1)}M`;
const TH = "px-2.5 pb-2.5 text-[9.5px] font-semibold uppercase tracking-[0.12em] text-[#8a8a8a] border-b border-[#3a3a3a]";
const TD = "px-2.5 py-[11px] border-b border-[#303030] text-[12.5px] text-[#b4b4b4] tabular-nums";

export default function BookTable({ book, onOpenDeal }) {
  const { rows, total, totalSf, psf, offMarket } = book;
  return (
    <section data-print-block className="rounded-[14px] border border-[#3a3a3a] bg-[#242424] px-6 py-5">
      <h3 className="text-[15px] font-semibold text-[#f4f4f4]">The book, deal by deal</h3>
      <p className="mt-0.5 text-[12px] text-[#8a8a8a]">Closest to close first</p>
      <div className="mt-4 overflow-x-auto">
        <table className="w-full border-collapse">
          <thead>
            <tr>
              <th className={`${TH} text-left`}>Deal</th>
              <th className={`${TH} text-left`}>Market</th>
              <th className={`${TH} text-left`}>Stage</th>
              <th className={`${TH} text-right`}>Book value</th>
              <th className={`${TH} text-right`}>SF</th>
              <th className={`${TH} text-right`}>$/SF</th>
              <th className={`${TH} text-right`}>Levered IRR</th>
              <th className={`${TH} text-right`}>Multiple</th>
              <th className={`${TH} text-left`}>Source</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} onClick={() => onOpenDeal?.(r.deal)} className="cursor-pointer hover:bg-[#2c2c2c]">
                <td className={`${TD} font-medium text-[#f4f4f4]`}>{r.name}</td>
                <td className={TD}>{r.market}</td>
                <td className={TD}>
                  <span className="inline-flex items-center gap-[7px]">
                    <span className="inline-block h-[9px] w-[9px] rounded-[2px]" style={{ background: stageRamp[r.stage] }} />
                    {STAGE_LABEL[r.stage]}
                  </span>
                </td>
                <td className={`${TD} text-right`}>{r.value > 0 ? M(r.value) : "—"}</td>
                <td className={`${TD} text-right`}>{r.sf ? Math.round(r.sf).toLocaleString() : "—"}</td>
                <td className={`${TD} text-right`}>{r.psf != null ? `$${Math.round(r.psf)}` : "—"}</td>
                <td className={`${TD} text-right`}>{r.irr != null ? `${r.irr.toFixed(1)}%` : "—"}</td>
                <td className={`${TD} text-right`}>{r.em != null ? `${r.em.toFixed(2)}x` : "—"}</td>
                <td className={TD}>{r.offMarket ? "Off-market" : "Marketed"}</td>
              </tr>
            ))}
            <tr>
              <td className={`${TD} border-b-0 font-medium text-[#f4f4f4]`}>Total</td>
              <td className={`${TD} border-b-0`} />
              <td className={`${TD} border-b-0`}>{rows.length} deal{rows.length === 1 ? "" : "s"}</td>
              <td className={`${TD} border-b-0 text-right font-medium text-[#f4f4f4]`}>{M(total)}</td>
              <td className={`${TD} border-b-0 text-right font-medium text-[#f4f4f4]`}>{Math.round(totalSf).toLocaleString()}</td>
              <td className={`${TD} border-b-0 text-right font-medium text-[#f4f4f4]`}>{psf != null ? `$${Math.round(psf)}` : "—"}</td>
              <td className={`${TD} border-b-0`} />
              <td className={`${TD} border-b-0`} />
              <td className={`${TD} border-b-0`}>{offMarket} off-market</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  );
}
